// extracted by mini-css-extract-plugin
export default {"input":"A--z","button":"B--z","selected":"C--z","unavailable":"D--z","oos":"E--z","image":"F--z","paperCutDisabledOverlay":"G--z"};